class RetainedData {
  static key = 'retainedData'

  static save = (data: { [key: string]: string | number }) => {
    const stored = this.get()
    const newValue = { ...stored, ...data }
    localStorage.setItem(this.key, JSON.stringify(newValue))
  }

  static get = (): { [key: string]: string | number } => {
    try {
      const stored = localStorage.getItem(this.key)
      return stored ? JSON.parse(stored) ?? {} : {}
    } catch (error) {
      return {}
    }
  }
}

export default RetainedData
